import { render, staticRenderFns } from "./TheVentaTipoServicio.vue?vue&type=template&id=2bafbb6a&scoped=true&"
import script from "./TheVentaTipoServicio.vue?vue&type=script&lang=js&"
export * from "./TheVentaTipoServicio.vue?vue&type=script&lang=js&"
import style0 from "./TheVentaTipoServicio.vue?vue&type=style&index=0&id=2bafbb6a&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bafbb6a",
  null
  
)

export default component.exports